import LocationCardList from "./LocationCardList";

export default LocationCardList;
